import React, { useState, useEffect } from "react";
const ContactIcons = () => {
  return (<div>Contacts</div>);
}

export default ContactIcons;
